import type { Primitive } from 'utility-types';

import { type TabClick, tabClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

export const tabClicked = (
  context: TrackingContextValue,
  data: TabClick & { tabIndex?: number },
  dimensions?: Record<string, Primitive | string[]>
) => {
  GAEvent({ action: 'Tab Pressed', label: data.tabName }, context, dimensions);
  tabClick(data, context);
};
